<template>
  <Toast position="bottom-right" />

  <section class="mb-8">
    <div class="page-header pt-5 pb-11">
      <span class="mask bg-gradient-dark"></span>
      <div class="grid grid-nogutter">
        <div class="col-5 md:col-2 flex justify-content-end align-items-center">
          <img class="icona-skin" src="../src/assets/img/logo_small.svg" />
        </div>
        <div class="col-5 md:col-3 md:col-offset-7 col-offset-1 flex justify-content-start align-items-start">
          <a target="_blank" href="https://askmanagement.it/it/">
            <Button label="SCOPRI ASK" class="p-button-rounded btn-black" />
          </a>
        </div>
        <div class="col-12 flex justify-content-center mt-5">
          <img src="../src/assets/img/logo.svg" height="100" />
        </div>
        <div class="wizard-title col-12 flex justify-content-center">
          WIZARD
        </div>
      </div>
    </div>

    <div class="wrapper-form">
      <div class="grid">
        <div class="xl:col-4 lg:col-5 md:col-7 col-9 mx-auto">
          <div class="card">
            <div class="card-body">
              <button @click="handleClickGetAuthCode" type="button" class="login-with-google-btn"
                :disabled="!Vue3GoogleOauth.isInit">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48" class="google-icon">
                  <path fill="#ffc107"
                    d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z">
                  </path>
                  <path fill="#ff3d00"
                    d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z">
                  </path>
                  <path fill="#4caf50"
                    d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z">
                  </path>
                  <path fill="#1976d2"
                    d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z">
                  </path>
                </svg>
                Sign in with Google
              </button>

              <hr class="hr-text" data-content="OR">

              <form class="mt-4">
                <div class="mb-3">
                  <input type="text" class="input-1" placeholder="Email" />
                </div>
                <div class="mb-3">
                  <input type="text" class="input-1" placeholder="Password" />
                </div>
                <div class="text-center">
                  <button class="btn-signin">
                    ACCEDI
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer class="footer py-5">
    <div class="grid">
      <div class="col-8 mx-auto text-center mt-1">
        <p class="mb-0">©{{ currentYear }} made AGF Team Software</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { useStore } from 'vuex'
import { computed, getCurrentInstance, inject } from 'vue'
import { useRouter } from 'vue-router';
import { useToast } from "primevue/usetoast";

export default {
  setup() {

    const self = getCurrentInstance();
    const gAuth = self.appContext.config.globalProperties.$gAuth
    const Vue3GoogleOauth = inject("Vue3GoogleOauth");
    const toast = useToast();
    const router = useRouter()
    const store = useStore()
    const currentYear = computed(() => new Date().getFullYear())

    const handleClickGetAuthCode = async () => {
      try {
        const authCode = await gAuth.getAuthCode();
        handleLogin(authCode)
      } catch (error) {
        console.error(error);
        return null;
      }
    }

    const handleLogin = async (authCode) => {
      store.dispatch("auth/login", authCode).then(
        (res) => {
          if (res == 503) {
            toast.add({ severity: 'error', summary: '503', detail: 'Servizio non disponibile', life: 3000 });
          } else if (res == null || !res.isAuthorized) {
            toast.add({ severity: 'error', summary: 'Non autorizzato', detail: 'Utente sconosciuto', life: 3000 });
          }
          else {
            router.push("/");
          }
        },
        (error) => {
          console.log(error)
        }
      );
    }

    return { currentYear, Vue3GoogleOauth, handleClickGetAuthCode }

  }
}
</script>

<style scoped>
.page-header {
  z-index: 1;
  height: 50%;
  min-height: 50vh;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  background-size: cover;
  margin: 0;
}

.mask {
  z-index: -2;
  position: absolute;
  background-size: cover;
  background-position: center center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #05b5a6 0%, #215159 100%);
}

.icona-skin {
  opacity: 0.8;
  height: 22px;
}

.btn-black {
  background-color: rgba(0, 0, 0, 0.8) !important;
  border: none !important;
  color: white !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 8px 24px !important;
}

.wizard-title {
  margin-top: -8px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 9px;
  letter-spacing: 16px;
  padding-left: 10px;
  font-weight: 300;
}

.wrapper-form {
  position: relative;
  margin-top: -200px;
  z-index: 4;
  padding: 0;
}

.card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  overflow: hidden;
  margin: 0 1rem;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.card-body {
  padding: 2rem;
}

.login-with-google-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 20px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background-color: white;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 1.5rem;
}

.login-with-google-btn:hover:not(:disabled) {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.login-with-google-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: #9ca3af;
  text-align: center;
  height: 1.5em;
  margin: 1.5rem 0;
}

.hr-text:before {
  content: "";
  background: #e5e7eb;
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}

.hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: #9ca3af;
  padding: 0 1rem;
  line-height: 1.5em;
  background-color: white;
  font-size: 12px;
  font-weight: 500;
}

.input-1 {
  box-sizing: border-box;
  height: 48px;
  width: 100%;
  border-radius: 8px;
  color: #374151;
  border: 1px solid #d1d5db;
  background: white;
  padding: 12px 16px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}

.input-1:focus {
  outline: none;
  border-color: #05b5a6;
  box-shadow: 0 0 0 3px rgba(5, 181, 166, 0.1);
}

.input-1::placeholder {
  color: #9ca3af;
}

.btn-signin {
  width: 100%;
  padding: 14px 20px;
  background: #05b5a6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-signin:hover {
  background: #048b80;
}

/* Footer */
.footer {
  color: #6b7280 !important;
  background: #f9fafb;
  margin: 0;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mb-8 {
  margin-bottom: 0 !important;
}

body,
html {
  margin: 0;
  padding: 0;
}

section {
  margin: 0 !important;
  padding: 0;
}

@media (max-width: 768px) {
  .page-header {
    min-height: 40vh;
  }

  .wrapper-form {
    margin-top: -150px;
    padding: 0 1rem;
  }

  .card {
    margin: 0 0.5rem;
  }

  .card-body {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .page-header {
    min-height: 35vh;
  }

  .wrapper-form {
    margin-top: -120px;
    padding: 0 0.5rem;
  }

  .card {
    margin: 0;
  }

  .card-body {
    padding: 1.5rem;
  }

  .wizard-title {
    font-size: 8px;
    letter-spacing: 12px;
  }
}
</style>